import { IFaireMoney } from '@faire/web-api--source/indigofair/data/IFaireMoney';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * Total amount of payment terms granted through OwF rounded to a nice number we're comfortable disclosing.
 */
export const OPEN_WITH_FAIRE_TOTAL_PAYMENT_TERMS_GRANTED =
  'OPEN_WITH_FAIRE_TOTAL_PAYMENT_TERMS_GRANTED' as SettingConst<
    'OPEN_WITH_FAIRE_TOTAL_PAYMENT_TERMS_GRANTED',
    IFaireMoney,
    'RETAILER' | 'VISITOR_WEB'
  >;
